import { Component, OnInit } from '@angular/core';
import { GamesGroupService, IPollQuestion } from '@fgb/core';
import { Observable } from 'rxjs';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrls: ['./polls-page.component.scss'],
})
export class PollsPageComponent implements OnInit {
  prodcutCode = ProductCode;
  pollsQuestion$: Observable<IPollQuestion[]>;

  constructor(private gamesGroupService: GamesGroupService) {}

  ngOnInit(): void {
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
  }
}
